import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SecurityPoliciesComponent} from './security-policies.component';
import {SearchModule} from '../../../components/search/search.module';
import {ActionBarModule} from '../../../components/action-bar/action-bar.module';
import {ArmTableModule} from '../../../components/arm-table/arm-table.module';
import {SecurityPoliciesDialogComponent} from './security-policies-dialog/security-policies-dialog.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {InfraModule} from 'ac-infra';
import {FormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {ClientFilterModule} from '../../../components/client-filter/client-filter.module';
import {DefaultSecurityPoliciesPipe} from './default-security-policies.pipe';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {RolesDisplayPipe} from './roles-display.pipe';
import {MatRadioModule} from '@angular/material/radio';

@NgModule({
  declarations: [
    SecurityPoliciesComponent,
    SecurityPoliciesDialogComponent,
    DefaultSecurityPoliciesPipe,
    RolesDisplayPipe
  ],
  imports: [
    CommonModule,
    SearchModule,
    FormsModule,
    ActionBarModule,
    ArmTableModule,
    MatFormFieldModule,
    InfraModule,
    MatInputModule,
    ClientFilterModule,
    MatCheckboxModule,
    MatRadioModule
  ]
})
export class SecurityPoliciesModule { }
